angular.module('picmonicng').factory('Tokens', [
  '$resource',
  function ($resource) {
    return $resource('/api/v3/user/tokens', {}, {});
  },
]);
